import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row mt-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/12 text-medium mt-4" }, " Country ", -1)
const _hoisted_3 = { class: "w-10/12 flex flex-row flex-wrap" }
const _hoisted_4 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_5 = ["id", "onUpdate:modelValue"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "flex flex-row mt-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/12 text-medium mt-4" }, " Supplier ", -1)
const _hoisted_9 = { class: "w-10/12 flex flex-row flex-wrap" }
const _hoisted_10 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_11 = ["id", "onUpdate:modelValue"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "flex flex-row mt-12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/12 text-medium mt-4" }, " Product ", -1)
const _hoisted_15 = { class: "w-10/12 flex flex-row flex-wrap" }
const _hoisted_16 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_17 = ["id", "onUpdate:modelValue"]
const _hoisted_18 = ["for"]
const _hoisted_19 = {
  key: 0,
  class: "flex flex-row mt-12"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/12 text-medium mt-4" }, " Contract ", -1)
const _hoisted_21 = { class: "w-10/12 flex flex-row flex-wrap" }
const _hoisted_22 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_23 = ["id", "onUpdate:modelValue"]
const _hoisted_24 = ["for"]
const _hoisted_25 = {
  key: 1,
  class: "flex flex-row mt-12"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/12 text-medium mt-4" }, " Service ", -1)
const _hoisted_27 = { class: "w-10/12 flex flex-row flex-wrap" }
const _hoisted_28 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_29 = ["id", "onUpdate:modelValue"]
const _hoisted_30 = ["for"]
const _hoisted_31 = { class: "flex flex-row mt-12 mb-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/12 text-medium mt-4" }, " Weight ", -1)
const _hoisted_33 = { class: "w-10/12 flex flex-row flex-wrap" }
const _hoisted_34 = { class: "flex flex-row items-center mr-8 mt-4 cursor-pointer" }
const _hoisted_35 = ["id", "onUpdate:modelValue"]
const _hoisted_36 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
    onConfirmClick: _ctx.handleFiltersConfirmClick
  }, {
    buttons: _withCtx(() => [
      _createVNode(_component_outline_button, {
        type: "outline",
        onClick: _ctx.handleResetFiltersButtonClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('general.reset_filters')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('general.filters')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFilters.country, (filter) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `country-filter-${filter.value}`
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer",
                    id: `country-filter-${filter.value}`,
                    "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event)
                  }, null, 8, _hoisted_5), [
                    [_vModelCheckbox, filter.checked]
                  ]),
                  _createElementVNode("label", {
                    class: "ml-2 cursor-pointer",
                    for: `country-filter-${filter.value}`
                  }, _toDisplayString(filter.value), 9, _hoisted_6)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFilters.supplier, (filter) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `supplier-filter-${filter.value}`
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer",
                    id: `supplier-filter-${filter.value}`,
                    "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event)
                  }, null, 8, _hoisted_11), [
                    [_vModelCheckbox, filter.checked]
                  ]),
                  _createElementVNode("label", {
                    class: "ml-2 cursor-pointer",
                    for: `supplier-filter-${filter.value}`
                  }, _toDisplayString(filter.value), 9, _hoisted_12)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFilters.product, (filter) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `product-filter-${filter.value}`
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer",
                    id: `product-filter-${filter.value}`,
                    "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event)
                  }, null, 8, _hoisted_17), [
                    [_vModelCheckbox, filter.checked]
                  ]),
                  _createElementVNode("label", {
                    class: "ml-2 cursor-pointer",
                    for: `product-filter-${filter.value}`
                  }, _toDisplayString(filter.value), 9, _hoisted_18)
                ])
              ]))
            }), 128))
          ])
        ]),
        (_ctx.filters.contract.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFilters.contract, (filter) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `contract-filter-${filter.value}`
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "cursor-pointer",
                        id: `contract-filter-${filter.value}`,
                        "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event)
                      }, null, 8, _hoisted_23), [
                        [_vModelCheckbox, filter.checked]
                      ]),
                      _createElementVNode("label", {
                        class: "ml-2 cursor-pointer",
                        for: `contract-filter-${filter.value}`
                      }, _toDisplayString(filter.value), 9, _hoisted_24)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filters.service.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFilters.service, (filter) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `service-filter-${filter.value}`
                  }, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "cursor-pointer",
                        id: `service-filter-${filter.value}`,
                        "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event)
                      }, null, 8, _hoisted_29), [
                        [_vModelCheckbox, filter.checked]
                      ]),
                      _createElementVNode("label", {
                        class: "ml-2 cursor-pointer",
                        for: `service-filter-${filter.value}`
                      }, _toDisplayString(filter.value), 9, _hoisted_30)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFilters.weight, (filter) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `weight-filter-${filter.value}`
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer",
                    id: `weight-filter-${filter.value}`,
                    "onUpdate:modelValue": ($event: any) => ((filter.checked) = $event)
                  }, null, 8, _hoisted_35), [
                    [_vModelCheckbox, filter.checked]
                  ]),
                  _createElementVNode("label", {
                    class: "ml-2 cursor-pointer",
                    for: `weight-filter-${filter.value}`
                  }, _toDisplayString(_ctx.$t('proposal.general.weight_bracket_header', {weight: filter.value / 1000})), 9, _hoisted_36)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onConfirmClick"]))
}